import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { Battery } from '../types';
import { apiService } from './api.service';

class BatteriesService {
  async getAllBatteries(status: string = STATUS_FILTER_VALUES.ALL): Promise<Battery[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Battery[]>(CR_API_ENDPOINTS.BATTERIES, params);
  }

  async getActiveBatteries(): Promise<Battery[]> {
    const params = { [QUERY_PARAMS.STATUS]: STATUS_FILTER_VALUES.ACTIVE };
    return apiService.get<Battery[]>(CR_API_ENDPOINTS.BATTERIES, params);
  }

  async getBatteriesByBrand(brandId: string, status: string = STATUS_FILTER_VALUES.ALL): Promise<Battery[]> {
    const params = { 
      [QUERY_PARAMS.BRAND_ID]: brandId,
      [QUERY_PARAMS.STATUS]: status
    };
    return apiService.get<Battery[]>(CR_API_ENDPOINTS.BATTERIES, params);
  }

  async getBatteryById(id: string): Promise<Battery> {
    return apiService.get<Battery>(`${CR_API_ENDPOINTS.BATTERIES}/${id}`);
  }

  async createBattery(batteryData: {
    batteryName: string;
    batteryModel: string;
    batteryBrandId: string;
    kwh?: number;
    current?: number;
  }): Promise<Battery> {
    return apiService.post<Battery>(CR_API_ENDPOINTS.BATTERIES, batteryData);
  }
}

export const batteriesService = new BatteriesService();